import { render } from "./MaterialsArticleArchiveTable.vue?vue&type=template&id=111bc355&scoped=true"
import script from "./MaterialsArticleArchiveTable.vue?vue&type=script&lang=js"
export * from "./MaterialsArticleArchiveTable.vue?vue&type=script&lang=js"

import "./MaterialsArticleArchiveTable.vue?vue&type=style&index=0&id=111bc355&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-111bc355"]])

export default __exports__